import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationPackageAvatar } from '@portal-core/translation-packages/components/translation-package-avatar/translation-package-avatar.component';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';


@NgModule({
  declarations: [
    TranslationPackageAvatar
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    TranslationPackageAvatar
  ]
})
export class TranslationPackageAvatarModule { }
